


































































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import BaseImage from '@shared/components/@atoms/BaseImage/BaseImage.vue';
import UCIcon from '@shared/components/@atoms/UCIcon/UCIcon.vue';
import UCSkeletonShimmer from '@shared/components/@atoms/UCSkeletonShimmer/UCSkeletonShimmer.vue';
import BaseCarouselItem from '@shared/components/@molecules/BaseCarouselItem/BaseCarouselItem.vue';
import BaseCarousel from '@shared/components/@organisms/BaseCarousel/BaseCarousel.vue';
import { ProductGalleryImage } from '@shared/types/IProduct';

import ExternalVideo from './internal/ExternalVideo.vue';
import ProductVideo from './internal/ProductVideo.vue';

export default defineComponent({
  name: 'UCProductGallery',
  components: {
    BaseCarousel,
    BaseCarouselItem,
    UCSkeletonShimmer,
    UCIcon,
    ProductVideo,
    ExternalVideo,
    BaseImage,
  },
  props: {
    loading: Boolean,
    productImages: {
      type: Array as PropType<ProductGalleryImage[]>,
      default: () => [],
    },
    tags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    tagsPosition: {
      type: String as PropType<'top-left' | 'top-right'>,
      default: 'top-right',
    },
    variantImageIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hasMultipleImages(): boolean {
      return this.productImages.length > 1;
    },
    cardTags(): string[] {
      return this.tags;
    },
    desktopImageUrl(): any {
      // @ts-ignore migrated from ui-library
      return this.productImages[0]?.desktop.url ?? '';
    },
    imageAlt(): any {
      // @ts-ignore migrated from ui-library
      return this.productImages[0]?.alt ?? '';
    },
  },
  methods: {
    getThumbnailClasses(isActive: boolean): any[] {
      const base = 'product-gallery__thumbnail';
      return [
        base,
        {
          [`${base}--active`]: isActive,
        },
      ];
    },
  },
});
